;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { atom } from 'jotai';

export enum MyListConfirmModalTypeEnum {
  SHOW = 'show',
  VIDEO = 'video',
  VIEWING_HISTORY = 'viewing-history',
  DEFAULT = '',
}
export interface MyListConfirmModalState {
  isOpen: boolean;
  id: string | null;
  slug: string | null;
  title: string | null;
  type: MyListConfirmModalTypeEnum;
}

export const defaultMyListConfirmModalState = {
  isOpen: false,
  id: null,
  slug: null,
  title: null,
  type: MyListConfirmModalTypeEnum.DEFAULT,
}

export const myListConfirmModalAtom = atom<MyListConfirmModalState>(defaultMyListConfirmModalState)
